import { render, staticRenderFns } from "./ProductPricing.vue?vue&type=template&id=cc72628a&scoped=true&"
import script from "./ProductPricing.vue?vue&type=script&lang=js&"
export * from "./ProductPricing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc72628a",
  null
  
)

export default component.exports